import { IsObject, IsOptional, IsString, ValidateNested, IsNumber } from 'class-validator';
import { Type } from 'class-transformer';

export class FingerprintDto {
	@IsOptional()
	@IsString()
	os?: string;

	@IsOptional()
	@IsString()
	device?: string;

	@IsOptional()
	@IsNumber()
	screenWidth?: number;

	@IsOptional()
	@IsNumber()
	screenHeight?: number;

	@IsOptional()
	@IsNumber()
	availWidth?: number;

	@IsOptional()
	@IsNumber()
	availHeight?: number;

	@IsOptional()
	@IsNumber()
	devicePixelRatio?: number;

	@IsOptional()
	@IsString()
	timezone?: string;

	@IsOptional()
	@IsNumber()
	hardwareConcurrency?: number;

	@IsOptional()
	@IsNumber()
	deviceMemory?: number;
}

export class SaveReferralFingerprintDto {
	@IsString()
	referralCode: string;

	@IsObject()
	@ValidateNested()
	@Type(() => FingerprintDto)
	fingerprint: FingerprintDto;

	@IsString()
	ipAddress: string;
}

export class GetReferralByFingerprintDto {
	@IsObject()
	@ValidateNested()
	@Type(() => FingerprintDto)
	fingerprint: FingerprintDto;

	@IsString()
	ipAddress: string;
}

export class GetReferralLinkDto {
	@IsString()
	referralCode: string;
}

export interface SaveReferralFingerprintResponse {
	success: boolean;
}

export interface GetReferralByFingerprintResponse {
	referralCode: string | null;
}
